import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
    fonts: {
        heading: '"Raleway", sans-serif',
        body: '"Raleway", sans-serif',
    },
    colors: {
        primary: {
            main: '#F99302',
            900: '#F99302',
            800: '#F99302',
            700: '#F99302',
            600: '#F99302',
            500: '#F99302',
            400: '#F99302',
            300: '#F99302',
            200: '#F99302',
            100: '#F99302',
        },
    },
    components: {
        Button: {
            baseStyle: {
                textTransform: 'uppercase',
                borderRadius: '2px',
                // make bigger on hover
                _hover: {
                    bg: '#FFF',
                    color: '#000',
                },
                // TODO: Maybe remove, not a part of the GCA design system
                _active: {
                    filter: 'brightness(0.9)',
                    _disabled: {
                        filter: 'brightness(1)',
                    },
                },
            },
            variants: {
                outline: {
                    border: '1px solid #fff',
                    color: '#fff',
                },
            },
        },
    },
 });

export default theme;
